import React, { useState } from "react";
import moment, { unix } from "moment";
import Whisper from "rsuite/esm/Whisper";
import Tooltip from "rsuite/esm/Tooltip";
import "../css/note-single.css";

const processHtml = (html, showReplies) => {
  if (!html) return "";

  const div = document.createElement("div");
  div.innerHTML = html;

  const quotes = div.querySelectorAll("blockquote");

  quotes.forEach((q) => {
    q.classList.add("gmail-quote");
    if (!showReplies) {
      q.style.display = "none";
    } else {
      q.style.display = "block";
    }
  });

  return div.innerHTML;
};

const AttachmentItem = ({ file, emailUser, messageId }) => {
  const isImage = file.mimeType && file.mimeType.includes("image");
  const isPdf = file.mimeType && file.mimeType.includes("pdf");
  const viewUrl = `${process.env.REACT_APP_CRM}/gmail/attachment/${emailUser}?message_id=${messageId}&attachment_id=${file.attachmentId}&mime_type=${file.mimeType}`;

  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const sizes = ["Bytes", "KB", "MB", "GB"];
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + " " + sizes[i];
  };

  const getFileIcon = (mimeType) => {
    if (!mimeType) return "fa-paperclip";
    if (mimeType.includes("image")) return "fa-image";
    if (mimeType.includes("pdf")) return "fa-file-pdf-o";
    if (
      mimeType.includes("word") ||
      mimeType.includes("officedocument.wordprocessingml")
    )
      return "fa-file-word-o";
    if (
      mimeType.includes("excel") ||
      mimeType.includes("officedocument.spreadsheetml")
    )
      return "fa-file-excel-o";
    if (mimeType.includes("zip") || mimeType.includes("compressed"))
      return "fa-file-archive-o";
    return "fa-paperclip";
  };

  const openFileInNewTab = (e) => {
    if (e) e.preventDefault();
    window.open(viewUrl, "_blank");
  };

  return (
    <React.Fragment>
      <div className="attachment-card">
        <div className="attachment-left">
          <div
            className="attachment-icon-box clickable"
            onClick={openFileInNewTab}
          >
            {isImage ? (
              <React.Fragment>
                <i className={`fa ${getFileIcon(file.mimeType)}`}></i>
              </React.Fragment>
            ) : (
              <i className={`fa ${getFileIcon(file.mimeType)}`}></i>
            )}
          </div>
          <div className="attachment-info" onClick={openFileInNewTab}>
            <div className="attachment-name" title={file.name}>
              {file.name}
            </div>
            <div className="attachment-meta">
              {formatBytes(file.size)} •{" "}
              {file.mimeType && file.mimeType.split("/")[1].toUpperCase()}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const NoteSingle = ({
  item,
  usersList,
  copyNotesLink,
  setCopyNotesLink,
  mauticId,
  customerName,
}) => {
  const [showDetails, setShowDetails] = useState(false);

  const [showReplies, setShowReplies] = useState(false);

  const isCustomer =
    item.note_type === "external" ||
    item.note_type === "customer" ||
    (item.note_type === "internal_email" && item.email_type === "sent");

  const isFromCustomer =
    item.note_type === "internal_email" && item.email_type === "received";

  const userName =
    item.note_type === "internal_email"
      ? item.email_type === "received"
        ? customerName
        : item.user_details && item.user_details.name
      : (usersList[item.user_uuid] && usersList[item.user_uuid].name) ||
        "Unknown User";

  const profilePic =
    item.note_type === "internal_email"
      ? item.user_details && item.user_details.profile_image
      : usersList[item.user_uuid] && usersList[item.user_uuid].profile_pic;

  const getInitials = (name) => {
    if (!name) return "??";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const handleCopyLink = () => {
    setCopyNotesLink(item.custom_note_uuid);
    setTimeout(() => {
      setCopyNotesLink("");
    }, 2000);
    navigator.clipboard.writeText(
      `${window.location.origin}/lead/${mauticId}#note${item.custom_note_uuid}`,
    );
  };

  const noteTypeClass = isCustomer
    ? "to-customer"
    : isFromCustomer
      ? "fromcustomer"
      : "internal";

  return (
    <div
      id={`note${item.custom_note_uuid}`}
      className={`note-card ${noteTypeClass} card-main`}
    >
      <div className="note-card-header">
        <div className="note-header-left">
          <div className="note-avatar">
            {profilePic ? (
              <img src={profilePic} alt={userName} />
            ) : (
              getInitials(userName)
            )}
          </div>
          <div className="note-user-info">
            <div className="note-user-top">
              <a
                href="#"
                className="note-user-name"
                onClick={(e) => e.preventDefault()}
              >
                {userName}
              </a>
              <Whisper
                placement="bottom"
                trigger="hover"
                speaker={
                  <Tooltip>
                    {copyNotesLink === item.custom_note_uuid
                      ? "Copied"
                      : "Copy"}
                  </Tooltip>
                }
              >
                <div onClick={handleCopyLink} className="note-link-icon">
                  <i className="fa fa-link"></i>
                </div>
              </Whisper>
              {isCustomer ? (
                <div className="note-badge customer bagde-customer">
                  To Customer
                </div>
              ) : isFromCustomer ? null : (
                <div className="note-badge internal bagde-internal">
                  Internal
                </div>
              )}
            </div>
            <div className="note-timestamp">
              {moment(unix(item.created_timestamp)).format(
                "D MMM YYYY [at] hh:mm A [IST]Z",
              )}
            </div>
          </div>
        </div>
        {/* <div className="note-header-right">
          <i className="fa fa-ellipsis-h"></i>
        </div> */}
      </div>

      {(item.inbox ||
        item.email_cc ||
        item.email_bcc ||
        item.from_email_address) && (
        <React.Fragment>
          <div
            className="note-details-toggle"
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails ? "Hide Details" : "Show Details"}
            <i className={`fa fa-chevron-${showDetails ? "up" : "down"}`}></i>
          </div>

          {showDetails && (
            <div className="note-details-content">
              {item.from_email_address && (
                <div className="note-detail-row">
                  <b>From:</b>{" "}
                  <span>
                    {JSON.parse(item.from_email_address).name} &lt;
                    {JSON.parse(item.from_email_address).email}&gt;
                  </span>
                </div>
              )}
              {item.to_email_address && (
                <div className="note-detail-row">
                  <b>To:</b> <span>{item.to_email_address}</span>
                </div>
              )}
              {item.email_cc && (
                <div className="note-detail-row">
                  <b>Cc:</b> <span>{item.email_cc}</span>
                </div>
              )}
              {item.email_bcc && (
                <div className="note-detail-row">
                  <b>Bcc:</b> <span>{item.email_bcc}</span>
                </div>
              )}
            </div>
          )}
        </React.Fragment>
      )}

      <div className="note-card-body">
        {item.title && (
          <div className="note-subject">
            <b>Sub:</b> {item.title}
          </div>
        )}

        {/* Main Content shown by default */}
        <div className="note-main-content">
          {item.highlight_text && (
            <blockquote
              className="quote-card"
              dangerouslySetInnerHTML={{ __html: item.highlight_text }}
            ></blockquote>
          )}
          <div
            className="note-content-text"
            dangerouslySetInnerHTML={{
              __html: processHtml(item.note_content, showReplies),
            }}
          />

          {item.note_content &&
            item.note_content.includes("<blockquote") &&
            (!showReplies ? (
              <div
                className="reply-toggle-dots"
                onClick={() => setShowReplies(true)}
                title="Show trimmed content"
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            ) : (
              <div
                className="reply-toggle-dots expanded"
                onClick={() => setShowReplies(false)}
                title="Hide trimmed content"
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            ))}
        </div>

        {/* Details Toggle for CC, BCC, etc. */}
        {
          console.log(
            "Note Item Details:",
            item,
          ) /* Debug log to check note details */
        }

        {/* Attachment Section */}
        {(() => {
          let attachments = [];
          if (item.email_attachments) {
            try {
              attachments =
                typeof item.email_attachments === "string"
                  ? JSON.parse(item.email_attachments)
                  : item.email_attachments;
            } catch (e) {
              console.error("Failed to parse attachments", e);
            }
          }

          if (attachments && attachments.length > 0) {
            // Derive user email and message_id for the attachment URL
            const emailUser = item.inbox;
            const messageId = item.email_message_id || item.message_id;

            return (
              <div className="note-attachments">
                {attachments.map((file, idx) => (
                  <AttachmentItem
                    key={idx}
                    file={file}
                    emailUser={emailUser}
                    messageId={messageId}
                  />
                ))}
              </div>
            );
          }
          return null;
        })()}
      </div>
    </div>
  );
};

export default NoteSingle;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/NoteSingle.js